<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <select class="form-select" v-model="newItem.from.category" :columns="3">
        <option :value=null>{{ $t('choose.label') }}</option>
        <option v-for="(category, index) in from.categories" v-if="showItem[index]" :key="category" :value="category">{{ category }}</option>
      </select>
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <div class="l-col-6@md">
      <div class="l-row">
        <form-group :label="`${$t('category.label')} ${$t('level.label')} ${(index + 1)}`" :columns="6" v-for="(categories, index) in to.categories" :key="categories">
          <select class="form-select" v-model="newItem.to.categories[index]" @change="getCategoryChildren(index)">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option v-for="category in categories" :key="category" :value="category.id">{{ category.name }}</option>
          </select>
        </form-group>
      </div>
    </div>

    <slot/>
  </div>
</template>

<script>
  import { omit } from '@/helper'
  import { isArray } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      from: {
        categories: []
      },
      to: {
        categories: []
      },
      newItem: {
        from: {
          category: null
        },
        to: {
          categories: [
            null
          ]
        }
      },
      items: [],
      alreadyExists: false,
      showItem: [],
      loaderCategoriesEcommerce: true,
      loaderCategoriesMarketplace: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(categories => {
          this.from.categories = categories
          this.loaderCategoriesEcommerce = false
          this.fillShowItem()
          this.$emit('showItem', true)
          this.$emit('loading', this.loaderCategoriesEcommerce || this.loaderCategoriesMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as categorias da Moovin.', 'Erro'))

      api.mercadoLivre.getCategories()
        .then(categories => {
          this.to.categories.push(categories)
          this.loaderCategoriesMarketplace = false
          this.$emit('showItem', true)
          this.$emit('loading', this.loaderCategoriesEcommerce || this.loaderCategoriesMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as categorias do Mercado Livre.', 'Erro'))
    },
    methods: {
      isEnableAddButton () {
        if (this.newItem.from.category !== null && this.newItem.to.categories.length) {
          return true
        }

        return false
      },
      getCategoryChildren (index) {
        if (this.newItem.to.categories[index] === null) {
          return false
        }

        this.$emit('loading', true)

        if (index <= (this.newItem.to.categories.length - 1)) {
          this.to.categories.splice(index + 1, this.to.categories.length)
          this.newItem.to.categories.splice(index + 1, this.newItem.to.categories.length)
        }
        api.mercadoLivre.getCategories('', this.newItem.to.categories[index])
          .then(categories => {
            this.to.categories.push(categories)
            this.$emit('loading', false)
          })
          .catch(err => {
            if (err.response.status !== 404) {
              notifier.error('Impossível carregar os tipos de produto do Mercado Livre.', 'Erro')
            }
            this.$emit('loading', false)
          })
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            category: this.newItem.from.category
          },
          to: {
            categories: []
          }
        }
        for (let i in this.newItem.to.categories) {
          if (!this.newItem.to.categories[i]) {
            continue
          }

          item.to.categories.push(this.newItem.to.categories[i])
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.category === item.from.category || (
              itemPreset.from.category === item.from.category &&
              JSON.stringify(itemPreset.to.categories) === JSON.stringify(item.to.categories)
            )
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return omit({
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'active': this.preset.active,
          'item': this.newItem
        })
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      },
      clearPresetAddItem () {
        if (!this.alreadyExists) {
          this.to.categories.splice(1, this.to.categories.length)
          this.newItem.to.categories[0] = null
          this.newItem.from.category = null
        }
      },
      fillShowItem () {
        if (isArray(this.from['categories']) && this.from['categories'].length) {
          for (let j in this.from['categories']) {
            const item = this.from['categories'][j]

            this.showItem[j] = true

            if (this.preset.items.find(preset => preset.from.category === item)) {
              this.showItem[j] = false
            }
          }
        }
      }
    },
    watch: {
      'newItem.to.categories' () {
        this.emitEnabledAdd()
      },
      'to.categories' (value) {
        for (let i in value) {
          let newItemCategory = this.newItem.to.categories[i]

          if (newItemCategory === undefined) {
            this.newItem.to.categories[i] = null
          }
        }
      },
      'preset.items' (value) {
        this.items = value

        this.fillShowItem()
      },
      'newItem.from.category' () {
        this.emitEnabledAdd()
      }
    },
    components: {
      Panel,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationAddItem.vue?a0a495dc